/**
 * Quotation Service API
 * This is the quotation-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RfqListItemDto { 
    id?: number;
    uid?: string;
    number?: string;
    type?: string;
    status?: string;
    dueDate?: Date;
    fullName?: string;
    phone?: string;
    email?: string;
    quoted?: number;
    sent?: string;
}

